import { Droplets, Moon } from "lucide-react";
import { NAME, SUB, IMG, ml, isToday } from "./cq";

const DoseRow = ({ d }) => (
  <li data-testid={`cq-dose-${d.id}`} className="flex items-center gap-3 rounded-[14px] bg-[#0F3D1E]/90 border border-[#8CD05A]/30 p-3">
    <img src={IMG[d.id]} alt="" className="w-12 h-12 object-contain shrink-0" />
    <span className="flex-1 min-w-0">
      <span className="block font-label text-lg text-white leading-tight">{NAME[d.id]}</span>
      {SUB[d.id] && <span className="block text-xs text-[#D7E8CF]">{SUB[d.id]}</span>}
    </span>
    <span className="text-right">
      <span className="block font-serif-d font-black text-2xl text-white leading-none">{ml(d.dose)}</span>
      <span className="block font-mono-d text-xs text-[#D7E8CF] mt-1">{d.dose} ml/L</span>
    </span>
  </li>
);

export const CqDay = ({ day, week, focus, focusLabel }) => {
  const today = isToday(day.date);
  const shown = focus ? day.doses.filter((d) => focus.includes(d.id)) : day.doses;
  const title = day.date.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" });
  return (
    <div data-testid="cq-day-card" className={`rounded-[22px] p-5 border-2 ${today ? "bg-[#1E7A3C] border-[#F2B441]" : "bg-[#0F3D1E]/85 border-[#8CD05A]/40"} backdrop-blur-md shadow-[0_20px_50px_-20px_rgba(0,0,0,0.7)]`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          {today && <span data-testid="cq-today-badge" className="inline-block font-mono-d text-xs tracking-[0.18em] uppercase bg-[#F2B441] text-[#0F3D1E] rounded-full px-3 py-1 mb-2">Hoy</span>}
          <p data-testid="cq-day-title" className="font-serif-d font-black text-2xl text-white first-letter:uppercase leading-tight">{title}</p>
          <p className="font-mono-d text-xs text-[#E6F2DF] mt-1">Semana {week.n} · {week.col} · {week.label}</p>
        </div>
        {day.water ? <Droplets className="w-9 h-9 text-[#BFE3FF] shrink-0" aria-hidden /> : <Moon className="w-9 h-9 text-[#F2B441] shrink-0" aria-hidden />}
      </div>
      {!day.water ? (
        <p data-testid="cq-day-rest" className="mt-4 text-lg text-white">{day.sunday ? "Domingo de descanso." : "Hoy no toca regar."} Descansa la planta y el sustrato.</p>
      ) : day.doses.length === 0 ? (
        <p data-testid="cq-day-flush" className="mt-4 text-lg text-white">Lavado: riega <strong>solo con agua</strong>, sin nutrientes.</p>
      ) : (
        <>
          <p className="mt-4 text-base text-white">Riego para <strong>100 L</strong> de agua:</p>
          {shown.length ? <ul className="mt-3 space-y-2">{shown.map((d) => <DoseRow key={d.id} d={d} />)}</ul>
            : <p data-testid="cq-day-no-focus" className="mt-3 rounded-[14px] bg-black/25 p-3 text-white">Esta semana no lleva {focusLabel}. Pulsa «Todos» para ver el riego completo.</p>}
        </>
      )}
    </div>
  );
};
